export default __webpack_public_path__ + "static/media/mar.2708b978.png";